import { TFunction } from 'i18next';
import { v4 as uuid4 } from 'uuid';
import {
  Message,
  MessageStatus,
  MessageType,
  WebClientSender,
} from '@/types/message.types';
import type { PreChatForm } from '@/types/widgetConfig';

export const getMessageTemplate = (): Message => {
  return {
    analyticTags: [],
    channel: 'livechat_v2',
    channelIdentityId: '',
    channelName: 'livechat_v2',
    companyId: '',
    conversationId: '',
    createdAt: new Date().toISOString(),
    deliveryType: 'Normal',
    id: '',
    isFromImport: false,
    isSandbox: false,
    isSentFromSleekflow: false,
    messageChecksum: '',
    messageContent: '',
    messageType: MessageType.TEXT,
    metadata: {},
    status: MessageStatus.FAILED,
    timestamp: Date.now() / 1000, // TODO: backlog, unify timestamp to be in milliseconds (13 digits)
    updatedAt: new Date().toISOString(),
    uploadedFiles: [],
    webClientSender: null as unknown as WebClientSender,
  };
};

export const getWelcomeMessageMock = (messageContent: string): Message => {
  return {
    ...getMessageTemplate(),
    id: uuid4(),
    createdAt: '',
    updatedAt: '',
    timestamp: 0,
    isSentFromSleekflow: true,
    messageContent,
    messageType: MessageType.TEXT,
    status: MessageStatus.SENT,
  };
};

export const getContactFormMessageMock = (
  preChatForm: PreChatForm,
): Message => {
  return {
    ...getMessageTemplate(),
    id: uuid4(),
    createdAt: '',
    updatedAt: '',
    timestamp: 0,
    isSentFromSleekflow: true,
    messageType: MessageType.INTERACTIVE,
    status: MessageStatus.SENT,
    extendedMessagePayload: { extendedMessageType: 501 },
    preChatForm,
  };
};

export const formatMessageTime = (timestamp: number) => {
  return new Date(timestamp * 1000).toLocaleTimeString([], {
    hour: 'numeric',
    minute: 'numeric',
  });
};

export const formatMessageDate = (timestamp: number, t: TFunction) => {
  const messageDate = new Date(timestamp * 1000);
  const today = new Date();

  if (messageDate.toDateString() === today.toDateString()) {
    return t('date.today');
  }

  return messageDate.toLocaleDateString([], {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};
